<script lang="ts">
    import type {DocumentDetailReactivePageData, DocumentDetailStaticPageData} from '../types';
    import {getPageContext} from 'shared/layouts/page-context';
    import KpComments from '../../kp-comments/KpComments.svelte';

    const pageContext = getPageContext<DocumentDetailStaticPageData, DocumentDetailReactivePageData>();
    const model = pageContext.staticData.model;
</script>

{#if model.commentsShowing}
    <KpComments document={model.record}
                allowAnonymousComments={model.anonymousCommentsEnabled}/>
{/if}